// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-section-editor-panel {
  height: 280px;
  width: 35%;
}
.fi-section-editor-panel.dialog-full-content .mat-mdc-dialog-content.fi-dialog-content {
  height: calc(100% - 75px);
}
.fi-section-editor-panel.cdk-overlay-pane .mat-mdc-dialog-container .mat-mdc-dialog-surface.mdc-dialog__surface .mat-mdc-dialog-title.mdc-dialog__title {
  margin: 0;
}
.fi-section-editor-panel .fi-common-two-buttons .footer .secondary-button {
  margin-right: 0;
}

.fi-section-edit-dialog .mat-mdc-form-field {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-sections-dnd-editor/fi-section-edit-dialog/fi-section-edit-dialog.component.scss"],"names":[],"mappings":"AAAA;EAII,aAAA;EACA,UAAA;AAFJ;AAFI;EACI,yBAAA;AAIR;AAAI;EAII,SAAA;AADR;AAGI;EACI,eAAA;AADR;;AAKI;EACI,WAAA;AAFR","sourcesContent":[".fi-section-editor-panel {\r\n    &.dialog-full-content .mat-mdc-dialog-content.fi-dialog-content {\r\n        height: calc(100% - 75px);\r\n    }\r\n    height: 280px;\r\n    width: 35%;\r\n    &.cdk-overlay-pane\r\n        .mat-mdc-dialog-container\r\n        .mat-mdc-dialog-surface.mdc-dialog__surface\r\n        .mat-mdc-dialog-title.mdc-dialog__title {\r\n        margin: 0;\r\n    }\r\n    .fi-common-two-buttons .footer .secondary-button {\r\n        margin-right: 0;\r\n    }\r\n}\r\n.fi-section-edit-dialog {\r\n    .mat-mdc-form-field {\r\n        width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
